import React from 'react';
import { Col, Row } from 'antd';
import { first, last } from 'lodash-es';

import { pxToNumber } from '../../../utils/cssUtils';
import { cssVariables } from '../../../styles/cssVariables';
import { QuoteFlightItinerary } from './QuoteFlightItinerary';
import NoticeSection from './NoticeSection';
import ShipmentDetails from './ShipmentDetails';
import FlightInformationSection from './components/FlightInformationSection';
import ContactInformation from './ContactInformation';
import QuoteDetailMap from './components/QuoteDetailMap';
import FlightFormatted from '../../../components/flights/FlightFormatted';
import { QuoteDriveItinerary } from './QuoteDriveItinerary';
import { isQuoteDirectDrive } from '../../../components/quotes/quoteUtils';
import { useQuoteContentLargeStyles } from './QuoteContantLarge.styles';

const QuoteContentLarge = ({ quoteDetail }) => {
  const { styles } = useQuoteContentLargeStyles();
  const firstFlight = first(quoteDetail.flights);
  const lastFlight = last(quoteDetail.flights);
  const isDirectDrive = isQuoteDirectDrive(quoteDetail);

  return (
    <Row
      gutter={[
        pxToNumber(cssVariables.spaceNorm2),
        pxToNumber(cssVariables.spaceNorm2),
      ]}
    >
      <ShipmentDetails
        title="shipmentDetail.pickupLocation"
        subtitle="book.quote.flightInformation.ready"
        dateTime={quoteDetail.pickupDateTime?.scheduled}
      >
        <FlightInformationSection
          sectionTitle="book.newQuote.fromPickUp"
          dateTime={quoteDetail.pickupDateTime?.scheduled}
          highlightedText={quoteDetail.origin?.companyName}
          address={quoteDetail.origin?.address}
          badgeLabel="RDY"
          distance={quoteDetail.origin?.airportDistance}
          noDistance={isDirectDrive}
        />

        {!isDirectDrive && (
          <FlightInformationSection
            tooltipText="book.newQuote.estimatedLockout"
            sectionTitle="book.newQuote.toDeliver"
            highlightedText={<FlightFormatted flight={firstFlight} />}
            flight={firstFlight}
            badgeLabel="L/O"
            noDistance
            flightRows={[
              {
                label: 'book.newQuote.departs',
                value: firstFlight?.departure?.estimated,
              },
            ]}
          />
        )}

        <ContactInformation contact={quoteDetail.origin?.contact} />
      </ShipmentDetails>

      <Col span={12} className={styles.flightItinerary}>
        <div style={{ marginBottom: '16px' }}>
          {isDirectDrive ? (
            <QuoteDriveItinerary quote={quoteDetail} />
          ) : (
            <QuoteFlightItinerary flights={quoteDetail.flights} />
          )}
        </div>
        <QuoteDetailMap quote={quoteDetail} />
        <NoticeSection />
      </Col>

      <ShipmentDetails
        title="shipmentDetail.deliveryLocation"
        subtitle="book.quote.flightInformation.estimatedDelivery"
        dateTime={quoteDetail?.deliveryDateTime?.scheduled}
      >
        {!isDirectDrive && (
          <FlightInformationSection
            sectionTitle="book.newQuote.fromPickUp"
            dateTime={lastFlight?.arrival?.estimated}
            highlightedText={<FlightFormatted flight={lastFlight} />}
            badgeLabel="RcvETA"
            distance={quoteDetail.destination?.airportDistance}
            flightRows={[
              {
                label: 'quoteDetail.flightArival',
                value: lastFlight?.arrival?.estimated,
              },
            ]}
          />
        )}

        <FlightInformationSection
          sectionTitle="book.newQuote.toDeliver"
          dateTime={quoteDetail.deliveryDateTime?.scheduled}
          highlightedText={quoteDetail.destination?.companyName}
          address={quoteDetail.destination?.address}
          badgeLabel="DDL"
          noDistance
        />
        <ContactInformation contact={quoteDetail.destination?.contact} />
      </ShipmentDetails>
    </Row>
  );
};

export default QuoteContentLarge;
